import { render, staticRenderFns } from "./MortgagePartners.vue?vue&type=template&id=5ec77f96&scoped=true&"
import script from "./MortgagePartners.vue?vue&type=script&lang=ts&"
export * from "./MortgagePartners.vue?vue&type=script&lang=ts&"
import style0 from "./MortgagePartners.vue?vue&type=style&index=0&id=5ec77f96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec77f96",
  null
  
)

export default component.exports